@for (link of socialLinks$ | async; track $index) {
  <a [href]="link.url" [attr.target]="link.target">
    @if (link.icon) {
      <img [src]="link.icon.url" [alt]="link.icon.altText" />
    }
  </a>
}
